import isObject from 'lodash/isObject';

type ErrorWithMessage = {
  message: string;
};

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return isObject(error) && 'message' in error && typeof (error as Record<string, unknown>).message === 'string';
}

export function getErrorMessage(error: unknown): string {
  return isErrorWithMessage(error) ? error.message : '';
}
